import { itemSchema } from './base-schemas'

export const addInvoiceItemPayloadSchema = itemSchema
